module.exports = __webpack_public_path__ + "media/8.7e0d2d65.mp3";